<template>
  <canvas v-if="" :id="name"></canvas>
</template>
<script>
  import Chart from "chart.js";
  import store from "../../store/store";

  export default {

    data() {
      return {
        // colors: [
        //   'rgba(192,216,73,0.50)',
        //   'rgba(244,116,39,0.50)',
        //   'rgba(250,226,57,0.50)',
        //   'rgba(24,139,113,0.50)',
        //   'rgba(237,28,36,0.50)',
        //   'rgba(7,67,87,0.50)',
        //   'rgba(13,147,207,0.5)',
        //   'rgba(90,90,90,0.50)',
        // ],
        chart: null,
        chartDataObject: {
          data: {
            datasets: [],
            labels: this.chartLabels,
            fontColor: '#fff',
          },
          type: this.type,
          options: {
            events: ['mousemove'], // this is needed, otherwise onHover is not fired
            onHover: (event, chartElement) => {
              event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            },
            // responsive:true,
            maintainAspectRatio: this.maintainRatio,
            animation: {
              duration: 0
            },
            legend: {

              display: this.legend,
              position: 'bottom',
              labels: {
                // borderWidth:2,
                usePointStyle:true,
                // fontColor: '#c6c7c8'
                fontColor: store.getters.theme === 'darkmode' ? '#fff' : 'dimgray',

              }
            },
            scale: {
              pointLabels: {
                // display:false,
                fontColor: store.getters.theme === 'darkmode' ? '#fff' : 'dimgray',
                // fontColor: '#f00',
                fontSize: 13,
                fontStyle: 'light'
              },
              angleLines: {
                display: true
              },
              gridLines: {
                color: store.getters.theme === 'darkmode' ? '#5e5e5e' : '#e5e5e5',
              },
              ticks: {
                display: this.ticks,
                showLabelBackdrop: false,
                fontColor: store.getters.theme === 'darkmode' ? '#fff' : 'dimgray',
                // fontColor: "#f00",
                // backgroundColor:false,
                backgroundColor: 'transparent',
                min: 0,
                max: 7,
                stepSize: 1,

              }
            }
          }
        }
      }
    },
    watch: {
      stateTheme() {
        if(this.chart){
          this.chart.options.legend.labels.fontColor = store.getters.theme === 'darkmode' ? '#fff' : 'dimgray';
          this.chart.options.scale.pointLabels.fontColor = store.getters.theme === 'darkmode' ? '#fff' : 'dimgray';
          this.chart.options.scale.gridLines.color = store.getters.theme === 'darkmode' ? '#5e5e5e' : '#e5e5e5';
          this.chart.options.scale.ticks.fontColor = store.getters.theme === 'darkmode' ? '#fff' : 'dimgray';
          this.chart.update()
        }
      },
      chartData(nv, ov) {
        this.setupChart();
      }
    },
    computed: {
      stateTheme() {
        return store.state.theme
      }
    },
    methods: {
      setupChart() {
        let data = [];
        this.chartDataObject.data.datasets = [];
        this.chartData.forEach((dataset, ind) => {
          let newset = null;
          if (this.type !== 'polarArea') {
            newset = this.dataSetObject(dataset, this.setLabels[ind], this.colors[ind])
          } else {
            newset = this.dataSetObject(dataset, this.setLabels[ind], this.colors)
          }
          if (this.type === 'bar') {
            this.chartDataObject.options = {
              animation: {
                duration: 0
              },
            };
            this.chartDataObject.options.scales = {
              fontColor: store.getters.theme === 'darkmode' ? '#fff' : 'dimgray',
              xAxes: [{

                gridLines: {
                  color: store.getters.theme === 'darkmode' ? '#5e5e5e' : '#e5e5e5'
                },
              }],
              yAxes: [{
                gridLines: {
                  color: store.getters.theme === 'darkmode' ? '#5e5e5e' : '#e5e5e5'
                },
                ticks: {
                  backgroundColor: 'transparent',
                  fontColor: store.getters.theme === 'darkmode' ? '#fff' : 'dimgray',
                  beginAtZero: true,
                  min: 0,
                  max: 7,
                  stepsize: 1,
                }
              }]
            }
          }

          data.push(newset)
        });
        this.chartDataObject.data.datasets = data;

        this.createChart(this.name, this.chartDataObject);


      },
      dataSetObject(data, label = 'Data', bgc = this.colors) {
        return {
          label: label,
          data: data,
          borderWidth: 0,
          // borderColor: 'rgb(198, 199, 200)',
          borderColor: bgc,
          backgroundColor: bgc,

          pointStyle:'circle'
        }
      },
      chartClickHandler(evt) {
        const el = this.chart.getElementsAtEvent(evt)
        this.$emit('clickData', el);
      },
      createChart(id, chartData) {
        // console.log('creating chart')
        if (this.chart) {
          this.chart.destroy();
        }
        const ctx = document.getElementById(id);
        this.chart = new Chart(ctx, chartData);

        document.getElementById(id).addEventListener(
          'click',
          (evt) => this.chartClickHandler(evt)
        )
      }
    },
    mounted() {
      this.setupChart()
    },
    props: {
      maintainRatio: {
        type: Boolean,
        default() {
          return false
        }
      },
      ticks: {
        type: Boolean,
        default() {
          return true
        }
      },
      setLabels: {
        type: Array,
        default() {
          return ['Current', 'Previous']
        }
      },
      legend: {
        type: Boolean,
        default() {
          return true
        }
      },
      type: {
        type: String,
        default() {
          return 'polarArea'
        }
      },
      chartData: {
        type: Array,
        default() {
          return []
        }
      },
      chartLabels: {
        type: Array,
        default
        () {
          return []
        }
      },
      name: {
        type: String,
        default
        () {
          return 'Chart'
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Charts/GenericChart.vue